import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // ... (your useStyles code)
}));

export const GeneralPageWrapper = ({ children, location }) => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    // This code will now run correctly when the location prop is defined
    if (typeof window !== 'undefined' && location) {
      const dataLayerEvent = {
        event: 'schema_fire',
        pagePath: location.pathname,
        pageTitle: document.title,
      };

      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
      
      // console.log('Data layer event pushed:', dataLayerEvent);
    }
  }, [location?.pathname]);

  return (
    <div
      className={`${classes.contentWrapper} ${
        isVisible ? classes.visible : ''
      }`}
    >
      {children}
    </div>
  );
};